import React from "react";
import { Snackbar, Typography, Box } from "@mui/material";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import { selectSavingCategoryIds } from "store/product-list/ProductListSelectors";
import { selectCategoryNamesByIds } from "store/category/CategorySelectors";
import AppState from "store/AppState";

const StyledSnackbar = styled(Snackbar)({
  bottom: "10px",
  left: "10px",
  right: "auto",
  transform: "none",
  zIndex: 9,
});

const ContentContainer = styled(Box)`
  background-color: ${({ theme }) => theme.palette.neutral.white};
  border: ${({ theme }) => `1px solid ${theme.palette.neutral.lightGrey}`};
  border-radius: 4px;
  display: inline-block;
  min-width: 200px;
  min-height: 60px;
`;

const Header = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.neutral.lightGrey}`,
  height: "16px",
  backgroundColor: theme.palette.neutral.darkGreyishBlue,
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "10px",
}));

const Title = styled("span")(({ theme }) => ({
  color: theme.palette.neutral.white,
  fontSize: "12px",
  marginLeft: 0,
}));

interface SavingSnackbarProps {
  open: boolean;
}

const SavingSnackbar: React.FC<SavingSnackbarProps> = ({ open }) => {
  const intl = useIntl();
  const savingCategoryIds = useSelector(selectSavingCategoryIds);
  const categoryNames = useSelector((state: AppState) =>
    selectCategoryNamesByIds(state, savingCategoryIds),
  );

  if (!open) {
    return null;
  }

  // Only show snackbar if there are categories being saved
  if (categoryNames.length === 0) {
    return null;
  }

  // Build the message with category names
  const categoryList = categoryNames.join(", ");
  const message = intl.formatMessage({
    id: "save.inProgress",
    defaultMessage: "Saving",
  }) + ` ${categoryList}...`;

  return (
    <StyledSnackbar
      open={open}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    >
      <ContentContainer>
        <Header>
          <Title>
            <Typography variant="syncBarHeader">{message}</Typography>
          </Title>
        </Header>
      </ContentContainer>
    </StyledSnackbar>
  );
};

export default SavingSnackbar;

